import { Link } from "react-router-dom";

import { Compass } from "lucide-react";
import { useTranslation } from "react-i18next";

import { EmptyState } from "@/components/shared/empty-state";
import { Button } from "@/components/ui/button";

export function NotFoundPage() {
  const { t } = useTranslation();
  return (
    <EmptyState
      icon={Compass}
      title={t("notFound.title")}
      text={t("notFound.text")}
      action={
        <Button asChild variant="outline" size="sm" className="rounded-xl">
          <Link to="/">{t("notFound.action")}</Link>
        </Button>
      }
    />
  );
}
